<script lang="ts" setup>
  import { useI18n } from 'vue-i18n'
  import { CYBER_ADDON_ID } from '@/shared/constants/addons.constants'
  import AddonTooltip from '@/shared/components/AddonTooltip/AddonTooltip.vue'

  interface Emits {
    (e: 'openCyberTooltip'): void
  }
  interface Props {
    id: string
    price: number
    travelersCount: number
  }

  const props = defineProps<Props>()
  const { t } = useI18n()
  const emit = defineEmits<Emits>()

  const getPolicyholderPriceText = () => [t('price'), t('qar'), props.price].join(' ')
</script>

<template>
  <div class="addon-text">
    <div v-if="id === CYBER_ADDON_ID" class="addon-amount">
      <AddonTooltip
        :label="t('addon.cyber.excess.label')"
        :amount="t('addon.cyber.excess.amount')"
        :info="t('addon.cyber.excess.info')"
        @open-tooltip="emit('openCyberTooltip')"
      />
      <p>{{ getPolicyholderPriceText() }}</p>
    </div>

    <template v-else>
      <p>{{ t('outbound.plans.plan_information.addon_quote_text') }}</p>
      <p>{{ t('outbound.plans.plan_information.addon_price_text', { price: props.price }) }}</p>
    </template>
  </div>
</template>

<style lang="scss" scoped>
  @import './AddonText';

  .addon-amount {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
</style>
